/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Conversion_Status_Generating_AudioInputs */

const en_conversion_status_generating_audio = /** @type {(inputs: Conversion_Status_Generating_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generating Audio`)
};

const es_conversion_status_generating_audio = /** @type {(inputs: Conversion_Status_Generating_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generando audio`)
};

/**
* | output |
* | --- |
* | "Generating Audio" |
*
* @param {Conversion_Status_Generating_AudioInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const conversion_status_generating_audio = /** @type {((inputs?: Conversion_Status_Generating_AudioInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Conversion_Status_Generating_AudioInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_conversion_status_generating_audio(inputs)
	return en_conversion_status_generating_audio(inputs)
});